module.exports = __webpack_public_path__ + "media/images/konintodoke/crown_1-d75006a4100fe9f5ab2ce66a1516a137.png";